var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "supportConfirm" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "arrow_flow2"
                  }
                }),
                _vm._v(" "),
                _c("section", [
                  _c("h1", [_vm._v("お問い合わせ内容確認")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "confirm_area" }, [
                    _c("div", { staticClass: "input_confirm" }, [
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.supportType) +
                              "：" +
                              _vm._s(_vm.supportData.supportType.label) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.supportMaker) +
                              "：" +
                              _vm._s(
                                _vm.supportData.supportMaker
                                  ? _vm.supportData.supportMaker.label
                                  : ""
                              ) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.supportTitle) +
                              "：" +
                              _vm._s(_vm.supportData.supportTitle) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.supportBody) +
                              "：" +
                              _vm._s(_vm.supportData.supportBody) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.userName) +
                              "：" +
                              _vm._s(_vm.supportData.userLastName) +
                              " " +
                              _vm._s(_vm.supportData.userFirstName) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.userNameKana) +
                              "：" +
                              _vm._s(_vm.supportData.userLastNameKana) +
                              " " +
                              _vm._s(_vm.supportData.userFirstNameKana) +
                              "\n                "
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.email) +
                              "：" +
                              _vm._s(_vm.supportData.email) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.label.tel) +
                              "：" +
                              _vm._s(_vm.supportData.tel) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control_btn_area" }, [
                    _c(
                      "div",
                      {
                        staticClass: "detail_btn5",
                        on: {
                          click: function($event) {
                            _vm.goBack()
                          }
                        }
                      },
                      [_vm._v("〈〈 内容を修正する")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "detail_btn2",
                        on: {
                          click: function($event) {
                            _vm.complete()
                          }
                        }
                      },
                      [_vm._v("お問い合わせを行う 〉〉")]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3434954d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3434954d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcSupportConfirm.vue
// module id = null
// module chunks = 